export default {"src":"/pro/_next/static/media/blast-icon.8b8e47b3.svg","height":10,"width":16,"blurWidth":0,"blurHeight":0};